import React from "react";

interface PlusIconProps {
  className?: string;
  fill?: string;
  height?: number;
  stroke?: string;
  width?: number;
}

const PlusIcon = ({
  className,
  fill = "none",
  height = 19,
  width = 18.917,
  stroke = "#fff"
}: PlusIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 18.917 19"
    className={className}
  >
    <g transform="translate(2 2.234)">
      <line
        y2="15"
        transform="translate(7.766 -0.234)"
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeWidth="4"
      />
      <line
        y2="14.917"
        transform="translate(14.917 7.459) rotate(90)"
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeWidth="4"
      />
    </g>
  </svg>
);

export default PlusIcon;
